import React from 'react';
import classnames from 'classnames';
import Layout from "../../../../core/layout";
import Panel from "../../../panel";
import Tooltip from "../../../../core/tooltip";
import { widths, sizes, directions, positions } from "../../../../../enums";
import { Avatar, MessagePlaceholder, Logo, SharingContent, Item } from "../common";
import SharingConstants from "../../constants";

var GoogleSharePreviewTemplate = function GoogleSharePreviewTemplate(p) {
  var _classnames;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sharing-schematic-preview', (_classnames = {}, _classnames["preview-" + p.network] = p.network, _classnames))
  }, /*#__PURE__*/React.createElement(Layout, {
    columns: widths.ONE
  }, /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Avatar, {
    title: SharingConstants.PREVIEW_CONFIG[p.name].userName,
    byline: "Shared publicly - " + SharingConstants.PREVIEW_DATE,
    network: p.network,
    name: p.name
  })), /*#__PURE__*/React.createElement(Layout.Row, {
    borders: directions.H
  }, /*#__PURE__*/React.createElement(MessagePlaceholder, {
    text: p.messagePlaceholder
  })), /*#__PURE__*/React.createElement(Tooltip, {
    isInline: false,
    tooltip: "Google will gather the details from your page and display them to the user to add their own message."
  }, /*#__PURE__*/React.createElement(Layout.Row, {
    borders: null
  }, /*#__PURE__*/React.createElement(Panel, {
    padding: {
      horizontal: sizes.S,
      vertical: sizes.S
    },
    hasBorder: false
  }, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Logo, {
    network: p.network,
    size: sizes.M
  }), /*#__PURE__*/React.createElement(SharingContent, {
    network: p.network,
    title: "Your page title",
    byline: "your experience link"
  })))))));
};

export default GoogleSharePreviewTemplate;
//# sourceMappingURL=google.js.map